import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bsbutton',
	templateUrl:'./BSButtonPage.html',
	styles: [],
	styleUrls:['./BSButtonPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSButtonPage
{
	mdContent_72 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.BSButton;
\`\`\``;
	mdContent_73 = `\`\`\`java
new BSButton<>()
\`\`\``;
	mdContent_74 = `\`\`\`java
new BSButton<>(String text)
\`\`\``;
	mdContent_75 = `\`\`\`java
var btn = new BSButton<>("Click Me");
btn.setPrimary(true);
btn.setSize(BSButtonSizeOptions.Btn_Lg);
\`\`\``;
	mdContent_76 = `\`\`\`java
var btn = new BSButtonDangerOutline<>();
btn.setText("Delete");
\`\`\``;
}
